import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { clearBandhaiSettlementDetail } from "../settlementformSlice";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import ShadowCard from "../../../components/common/ShadowCard";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { Typography } from "@progress/kendo-react-common";
import { IKarigarListByProcess } from "../../karigar/karigarModel";
import { getKarigarListByProcess } from "../../karigar/services/karigar.services";
import { PROCESS_ID } from "../../../_contstants/common";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import {
  getBandhaiSettlementDetail,
  updateBandhaiSettlementDetail,
} from "../services/settlementform.services";
import moment from "moment";
import { formatWeight } from "../../../_helper/helper";
// import FormTextField from "../../../components/formFields/FormTextField";
import { sumBy } from "lodash";
import { LoadingPanel } from "../../../components/layout/Loading";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

const BandhaiSettlementForm = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const loading = useAppSelector((state) => state.settlementform.loading);
  const [karigarID, setKarigarID] = useState();
  const BandhaiSettlementDetail = useAppSelector(
    (state) => state.settlementform.BandhaiSettlementDetail,
  );
  const KarigarListByProcess = useAppSelector(
    (state) => state.karigar?.KarigarListByProcess,
  );
  // console.log("BandhaiSettlementDetail", BandhaiSettlementDetail);
  useEffect(() => {
    dispatch(getKarigarListByProcess(PROCESS_ID.bandhai));
    return () => {
      dispatch(clearBandhaiSettlementDetail());
    };
  }, []);

  const getDistinctIdsAsString = (
    data: any[],
    key: "BandhaiId" | "ReceiptId",
  ): string => {
    return Array.from(
      new Set(
        data
          ?.map((item) => item?.[key])
          .filter((id): id is number => typeof id === "number"),
      ),
    ).join(",");
  };

  const handleSubmitView = async (values: any) => {
    try {
      const payload = {
        KarigarId: values.karigar_id ? +values.karigar_id : null,
      };
      await dispatch(getBandhaiSettlementDetail(payload));
      setKarigarID(values.karigar_id);
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  // const handleSubmitSettlement = async (values: any) => {
  const handleSubmitSettlement = async () => {
    const BandhaiIds = getDistinctIdsAsString(
      [
        ...(BandhaiSettlementDetail?.bandhaiissueorders ?? []),
        ...(BandhaiSettlementDetail?.bandhaiapprovalitems ?? []),
        ...(BandhaiSettlementDetail?.bandhaigoldissue ?? []),
      ],
      "BandhaiId",
    );

    const ReceiptIds = getDistinctIdsAsString(
      [
        ...(BandhaiSettlementDetail?.bansdhaireceiptorders ?? []),
        ...(BandhaiSettlementDetail?.bansdaireceiptapprovalItems ?? []),
        ...(BandhaiSettlementDetail?.bansdaireceiptgoldreceive ?? []),
      ],
      "ReceiptId",
    );
    if (BandhaiIds !== "" || ReceiptIds !== "") {
      try {
        const payload = {
          BandhaiIds,
          ReceiptIds,
        };
        const res = await dispatch(updateBandhaiSettlementDetail(payload));
        if (res?.meta?.requestStatus === "fulfilled" && karigarID) {
          await dispatch(getBandhaiSettlementDetail({ KarigarId: karigarID }));
          SuccessToast("Sattlement successfully");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      ErrorToast("No Pending Settlement");
    }
  };

  const totalOrderIssueWeight =
    BandhaiSettlementDetail?.bandhaiissueorders?.reduce(
      (total, value) => (value ? total + value.IssueWeight : total),
      0,
    );

  const totalApprovalItemsIssueWeight =
    BandhaiSettlementDetail?.bandhaiapprovalitems?.reduce(
      (total, value) => (value ? total + value.weight : total),
      0,
    );

  const totalGoldIssueIssueWeight =
    BandhaiSettlementDetail?.bandhaigoldissue?.reduce(
      (total, value) => (value ? total + value.given_weight : total),
      0,
    );

  const totalIssueWeight =
    (totalOrderIssueWeight || 0) +
    (totalApprovalItemsIssueWeight || 0) +
    (totalGoldIssueIssueWeight || 0);

  const totalReceiptOrderGrossWeight =
    BandhaiSettlementDetail?.bansdhaireceiptorders?.reduce(
      (total, value) => (value ? total + value.net_weight : total),
      0,
    );

  const totalApprovalItemReturnWeight =
    BandhaiSettlementDetail?.bansdaireceiptapprovalItems?.reduce(
      (total, value) => (value ? total + (value.return_weight || 0) : total),
      0,
    );

  const totalGoldReceiveWeight =
    BandhaiSettlementDetail?.bansdaireceiptgoldreceive?.reduce(
      (total, value) => (value ? total + (value.ReceiveWeight || 0) : total),
      0,
    );

  const totalReceiptWeight =
    (totalReceiptOrderGrossWeight || 0) +
    (totalApprovalItemReturnWeight || 0) +
    (totalGoldReceiveWeight || 0);

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <GridLayout gap={{ rows: 10, cols: 10 }} cols={[{ width: "100%" }]}>
        <GridLayoutItem>
          <ShadowCard>
            <Form
              // initialValues={}
              onSubmit={handleSubmitView}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ width: "100%" }}>
                  <GridLayout
                    style={{ marginRight: 20 }}
                    gap={{ rows: 0, cols: 10 }}
                    cols={[
                      { width: "25%" },
                      { width: "25%" },
                      { width: "25%" },
                      { width: "25%" },
                    ]}
                  >
                    <GridLayoutItem colSpan={4}>
                      <Typography.h4
                        style={{ marginBottom: 0, marginLeft: "3px" }}
                      >
                        Bandhai Settlement Form
                      </Typography.h4>
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="karigar_id"
                        label="Karigar Name"
                        placeholder="Select Karigar"
                        component={FormSelectionField}
                        options={KarigarListByProcess?.map(
                          (karigar: IKarigarListByProcess) => {
                            return {
                              value: karigar?.karigar_id,
                              label: `${karigar?.karigar_nick_name || karigar?.karigar_name}`,
                            };
                          },
                        )}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        position: "relative",
                      }}
                    >
                      <ButtonWithLoading
                        label="View"
                        type="submit"
                        style={{ position: "absolute", top: 42 }}
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </ShadowCard>
        </GridLayoutItem>
        {BandhaiSettlementDetail && (
          <GridLayoutItem>
            {/* <ShadowCard> */}
            <GridLayout
              style={{ marginRight: 20, fontSize: "13px" }}
              gap={{ rows: 0, cols: 10 }}
              cols={[{ width: "40%" }, { width: "60%" }]}
            >
              <GridLayoutItem>
                <div
                  style={{
                    scrollbarWidth: "thin",
                    marginTop: 10,
                  }}
                >
                  <table className="table table-striped table-bordered table-hover field-array-table">
                    <thead>
                      <tr>
                        <th className="text-center" colSpan={5}>
                          <h5 className="m-0">Issue Orders</h5>
                        </th>
                      </tr>
                      <tr>
                        <th className="text-center">Orders No</th>
                        <th className="text-center">Issue Date</th>
                        <th className="text-center">Item Name</th>
                        <th className="text-center">Issue Weight (gm)</th>
                        <th className="text-center">Purity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {BandhaiSettlementDetail?.bandhaiissueorders?.map(
                        (issueorders) => (
                          <tr>
                            <td className="text-center">
                              {issueorders.order_no}
                            </td>
                            <td className="text-center">
                              {issueorders.issue_date
                                ? moment(
                                    issueorders.issue_date,
                                    "MM/DD/YYYY",
                                  ).format("DD MMM YYYY")
                                : ""}
                            </td>
                            <td className="text-center">
                              {issueorders.item_name}
                            </td>
                            <td className="text-center">
                              {issueorders.IssueWeight
                                ? formatWeight(issueorders.IssueWeight)
                                : ""}
                            </td>
                            <td className="text-center">
                              {issueorders.purity}
                            </td>
                          </tr>
                        ),
                      )}
                      <tr
                        style={{
                          fontSize: "16px",
                          borderTop: "2px solid darkgray",
                          backgroundColor: "#c2c2c2",
                        }}
                      >
                        <th colSpan={3} className="text-end">
                          Total:
                        </th>
                        <th className="text-center">
                          {formatWeight(totalOrderIssueWeight)}
                        </th>
                        <th></th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    scrollbarWidth: "thin",
                    marginTop: 10,
                  }}
                >
                  <table className="table table-striped table-bordered table-hover field-array-table">
                    <thead>
                      <tr>
                        <th className="text-center" colSpan={6}>
                          <h5 className="m-0">Approval Items</h5>
                        </th>
                      </tr>
                      <tr>
                        <th className="text-center">Orders No</th>
                        <th className="text-center">Issue Date</th>
                        <th className="text-center">Item Name</th>
                        <th className="text-center">Weight (gm)</th>
                        <th className="text-center">Qty.</th>
                        <th className="text-center">Unit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {BandhaiSettlementDetail?.bandhaiapprovalitems?.map(
                        (approvalItem) => (
                          <tr>
                            <td className="text-center">
                              {approvalItem.order_no}
                            </td>
                            <td className="text-center">
                              {approvalItem.IssueDate
                                ? moment(
                                    approvalItem.IssueDate,
                                    "MM/DD/YYYY",
                                  ).format("DD MMM YYYY")
                                : ""}
                            </td>
                            <td className="text-center">
                              {approvalItem.item_name}
                            </td>
                            <td className="text-center">
                              {approvalItem.weight
                                ? formatWeight(approvalItem.weight)
                                : ""}
                            </td>
                            <td className="text-center">{approvalItem?.qty}</td>
                            <td className="text-center">
                              {approvalItem?.unit_name}
                            </td>
                          </tr>
                        ),
                      )}
                      <tr
                        style={{
                          fontSize: "16px",
                          borderTop: "2px solid darkgray",
                          backgroundColor: "#c2c2c2",
                        }}
                      >
                        <th colSpan={3} className="text-end">
                          Total:
                        </th>
                        <th className="text-center">
                          {formatWeight(totalApprovalItemsIssueWeight)}
                        </th>
                        <th></th>
                        <th></th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    scrollbarWidth: "thin",
                    marginTop: 10,
                  }}
                >
                  <table className="table table-striped table-bordered table-hover field-array-table">
                    <thead>
                      <tr>
                        <th className="text-center" colSpan={6}>
                          <h5 className="m-0">Gold Issue Detail</h5>
                        </th>
                      </tr>
                      <tr>
                        <th className="text-center">Orders No</th>
                        <th className="text-center">Issue Date</th>
                        <th className="text-center">Item Name</th>
                        <th className="text-center">Weight (gm)</th>
                        <th className="text-center">Qty.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {BandhaiSettlementDetail?.bandhaigoldissue?.map(
                        (goldIssue) => (
                          <tr>
                            <td className="text-center">
                              {goldIssue.order_no}
                            </td>
                            <td className="text-center">
                              {goldIssue.IssueDate
                                ? moment(
                                    goldIssue.IssueDate,
                                    "MM/DD/YYYY",
                                  ).format("DD MMM YYYY")
                                : ""}
                            </td>
                            <td className="text-center">
                              {goldIssue.item_name}
                            </td>
                            <td className="text-center">
                              {goldIssue.given_weight
                                ? formatWeight(goldIssue.given_weight)
                                : ""}
                            </td>
                            <td className="text-center">{goldIssue?.pcs}</td>
                          </tr>
                        ),
                      )}
                      <tr
                        style={{
                          fontSize: "16px",
                          borderTop: "2px solid darkgray",
                          backgroundColor: "#c2c2c2",
                        }}
                      >
                        <th colSpan={3} className="text-end">
                          Total:
                        </th>
                        <th className="text-center">
                          {formatWeight(totalGoldIssueIssueWeight)}
                        </th>
                        <th></th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </GridLayoutItem>
              <GridLayoutItem>
                <div
                  style={{
                    scrollbarWidth: "thin",
                    marginTop: 10,
                  }}
                >
                  <table className="table table-striped table-bordered table-hover field-array-table">
                    <thead>
                      <tr>
                        <th className="text-center" colSpan={6}>
                          <h5 className="m-0">Receipt Orders</h5>
                        </th>
                      </tr>
                      <tr>
                        <th className="text-center">Orders No</th>
                        <th className="text-center">Receipt Date</th>
                        <th className="text-center">Item Name</th>
                        <th className="text-center">Gross Wt. (gm)</th>
                        <th className="text-center">Stone Wt. (gm)</th>
                        <th className="text-center">Net Wt. (gm)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {BandhaiSettlementDetail?.bansdhaireceiptorders?.map(
                        (receiptorders) => (
                          <tr>
                            <td className="text-center">
                              {receiptorders.order_no}
                            </td>
                            <td className="text-center">
                              {receiptorders.receipt_date
                                ? moment(
                                    receiptorders.receipt_date,
                                    "MM/DD/YYYY",
                                  ).format("DD MMM YYYY")
                                : ""}
                            </td>
                            <td className="text-center">
                              {receiptorders.item_name}
                            </td>
                            <td className="text-center">
                              {receiptorders.gross_weight
                                ? formatWeight(receiptorders.gross_weight)
                                : ""}
                            </td>
                            <td className="text-center">
                              {receiptorders.stone_weight
                                ? formatWeight(receiptorders.stone_weight)
                                : ""}
                            </td>
                            <td className="text-center">
                              {receiptorders.net_weight
                                ? formatWeight(receiptorders.net_weight)
                                : ""}
                            </td>
                          </tr>
                        ),
                      )}
                      <tr
                        style={{
                          fontSize: "16px",
                          borderTop: "2px solid darkgray",
                          backgroundColor: "#c2c2c2",
                        }}
                      >
                        <th colSpan={3} className="text-end">
                          Total:
                        </th>
                        <th className="text-center">
                          {formatWeight(totalReceiptOrderGrossWeight)}
                        </th>
                        <th className="text-center">
                          {formatWeight(
                            sumBy(
                              BandhaiSettlementDetail?.bansdhaireceiptorders,
                              "stone_weight",
                            ),
                          )}
                        </th>
                        <th className="text-center">
                          {formatWeight(
                            sumBy(
                              BandhaiSettlementDetail?.bansdhaireceiptorders,
                              "net_weight",
                            ),
                          )}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    scrollbarWidth: "thin",
                    marginTop: 10,
                  }}
                >
                  <table className="table table-striped table-bordered table-hover field-array-table">
                    <thead>
                      <tr>
                        <th className="text-center" colSpan={6}>
                          <h5 className="m-0">Approval Items</h5>
                        </th>
                      </tr>
                      <tr>
                        <th className="text-center">Orders No</th>
                        <th className="text-center">Receipt Date</th>
                        <th className="text-center">Item Name</th>
                        <th className="text-center">Weight (gm)</th>
                        <th className="text-center">Return Wt. (gm)</th>
                        <th className="text-center">Used Wt. (gm)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {BandhaiSettlementDetail?.bansdaireceiptapprovalItems?.map(
                        (approvalItem) => (
                          <tr>
                            <td className="text-center">
                              {approvalItem.order_no}
                            </td>
                            <td className="text-center">
                              {approvalItem.receipt_date
                                ? moment(
                                    approvalItem.receipt_date,
                                    "MM/DD/YYYY",
                                  ).format("DD MMM YYYY")
                                : ""}
                            </td>
                            <td className="text-center">
                              {approvalItem.item_name}
                            </td>
                            <td className="text-center">
                              {approvalItem.weight
                                ? formatWeight(approvalItem.weight)
                                : ""}
                            </td>
                            <td className="text-center">
                              {approvalItem.return_weight
                                ? formatWeight(approvalItem.return_weight)
                                : ""}
                            </td>
                            <td className="text-center">
                              {approvalItem.used_weight
                                ? formatWeight(approvalItem.used_weight)
                                : ""}
                            </td>
                          </tr>
                        ),
                      )}
                      <tr
                        style={{
                          fontSize: "16px",
                          borderTop: "2px solid darkgray",
                          backgroundColor: "#c2c2c2",
                        }}
                      >
                        <th colSpan={3} className="text-end">
                          Total:
                        </th>
                        <th className="text-center">
                          {formatWeight(
                            sumBy(
                              BandhaiSettlementDetail?.bansdaireceiptapprovalItems,
                              "balance_weight",
                            ),
                          )}
                        </th>
                        <th className="text-center">
                          {formatWeight(totalApprovalItemReturnWeight)}
                        </th>
                        <th className="text-center">
                          {formatWeight(
                            sumBy(
                              BandhaiSettlementDetail?.bansdaireceiptapprovalItems,
                              "used_weight",
                            ),
                          )}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    scrollbarWidth: "thin",
                    marginTop: 10,
                  }}
                >
                  <table className="table table-striped table-bordered table-hover field-array-table">
                    <thead>
                      <tr>
                        <th className="text-center" colSpan={4}>
                          <h5 className="m-0">Gold Received Details</h5>
                        </th>
                      </tr>
                      <tr>
                        <th className="text-center">Receive Date</th>
                        <th className="text-center">Item Name</th>
                        <th className="text-center">Weight (gm)</th>
                        <th className="text-center">Qty.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {BandhaiSettlementDetail?.bansdaireceiptgoldreceive?.map(
                        (goldReceive) => (
                          <tr key={Math.random()}>
                            <td className="text-center">
                              {goldReceive.ReceiveDate
                                ? moment(
                                    goldReceive.ReceiveDate,
                                    "MM/DD/YYYY",
                                  ).format("DD MMM YYYY")
                                : ""}
                            </td>
                            <td className="text-center">
                              {goldReceive.item_name}
                            </td>
                            <td className="text-center">
                              {goldReceive.ReceiveWeight
                                ? formatWeight(goldReceive.ReceiveWeight)
                                : ""}
                            </td>
                            <td className="text-center">{goldReceive?.pcs}</td>
                          </tr>
                        ),
                      )}
                      <tr
                        style={{
                          fontSize: "16px",
                          borderTop: "2px solid darkgray",
                          backgroundColor: "#c2c2c2",
                        }}
                      >
                        <th colSpan={2} className="text-end">
                          Total:
                        </th>
                        <th className="text-center">
                          {formatWeight(totalGoldReceiveWeight)}
                        </th>
                        <th></th>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  style={{
                    scrollbarWidth: "thin",
                    marginTop: 10,
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <table className="table table-striped table-bordered table-hover field-array-table w-50">
                    <tbody>
                      <tr
                        style={{
                          fontSize: "16px",
                          borderTop: "2px solid darkgray",
                          backgroundColor: "#c2c2c2",
                        }}
                      >
                        <td className="text-end">A = Total Issue Weight: </td>
                        <td>{formatWeight(totalIssueWeight)}</td>
                      </tr>
                      <tr
                        style={{
                          fontSize: "16px",
                          borderTop: "2px solid darkgray",
                          backgroundColor: "#c2c2c2",
                        }}
                      >
                        <td className="text-end">B = Total Receipt Weight: </td>
                        <td>{formatWeight(totalReceiptWeight)}</td>
                      </tr>
                      <tr
                        style={{
                          fontSize: "16px",
                          borderTop: "2px solid darkgray",
                          backgroundColor: "#c2c2c2",
                        }}
                      >
                        <td className="text-end">A-B = Total Weight:</td>
                        <td>
                          {formatWeight(totalIssueWeight - totalReceiptWeight)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </GridLayoutItem>
              <GridLayoutItem></GridLayoutItem>
              <GridLayoutItem style={{ display: "flex", alignItems: "end" }}>
                <Form
                  initialValues={{ settlement_amount: 1 }}
                  // onSubmit={handleSubmitSettlement}
                  render={() => (
                    <FormElement style={{ width: "100%" }}>
                      <GridLayout
                        style={{ marginRight: 10, marginBottom: 50 }}
                        gap={{ rows: 10, cols: 10 }}
                        cols={[{ width: "50%" }, { width: "50%" }]}
                      >
                        <GridLayoutItem></GridLayoutItem>
                        <GridLayoutItem
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ButtonWithLoading
                            onClick={handleSubmitSettlement}
                            label="Settlement"
                            type="button"
                            disabled={loading}
                            loading={loading}
                          />
                        </GridLayoutItem>
                      </GridLayout>
                    </FormElement>
                  )}
                />
              </GridLayoutItem>
            </GridLayout>
            {/* </ShadowCard> */}
          </GridLayoutItem>
        )}
      </GridLayout>
    </>
  );
};

export default BandhaiSettlementForm;
